import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.html',
  styleUrls: ['./image-cropper.scss'],
})
export class ImageCropperComponent implements OnInit {
  @Input('url') url: any = '';
  @Output('setbase64') setbase64 = new EventEmitter();
  @Input('type') type = 'base64';
  @Input('size') size = 1;
  @Input('rounded') rounded = true;
  @Input('fontPage') fontPage = false;

  containWithinAspectRatio = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  file: any;

  defaultImage: String = 'assets/img/logo.png';
  showCropp = false;
  canvasRotation = 0;
  scale = 0;
  transform: ImageTransform = {
    scale: 0,
    flipH: false,
    flipV: false,
  };

  constructor() {}

  ngOnInit(): void {}

  cropperReady(event) {}

  fileChangeListener(event) {
    this.file = event.target.files[0];
    this.imageChangedEvent = event;
    this.showCropp = true;
  }

  imageCropped = async (event: ImageCroppedEvent) => {
    try {
      const base64String = await this.blobToBase64(event.blob);
      this.setbase64.emit(base64String);
    } catch (error) {
      console.error('Error al convertir Blob a Base64:', error);
    }
  };

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        // Elimina el encabezado de data URL
        //const base64WithoutHeader = base64String.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = () => {
        reject('Error al leer el Blob como Base64');
      };
      reader.readAsDataURL(blob);
    });
  }

  loadImageFailed() {}

  LoadedImage(event) {}

  checkImage = async (url) => {
    const res = await fetch(url);
    const buff = await res.blob();

    return buff.type.startsWith('image/');
  };

  toggleContainWithinAspectRatio() {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  imageLoaded() {}

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  zoomOut() {
    this.scale -= 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  zoomIn() {
    this.scale += 0.1;
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  returnImage() {
    return this.url ? this.url : this.defaultImage;
  }
}
